// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 8C4 3.58172 7.58172 0 12 0C16.4183 0 20 3.58172 20 8V12.6972L22 15.6972V20H2V15.6972L4 12.6972V8ZM11 6V12H13V6H11ZM13.0039 13.5H11V15.5039H13.0039V13.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M8.64453 21C9.07481 22.4457 10.4141 23.5 11.9996 23.5C13.5851 23.5 14.9244 22.4457 15.3547 21H8.64453Z"}}]};

const NotificationErrorFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'notification-error-filled',
    ref,
    icon: element,
  },
));

NotificationErrorFilledIcon.displayName = 'NotificationErrorFilledIcon';

export default NotificationErrorFilledIcon;
